

import React, { memo } from 'react';
import { Dropdown } from '../../../../../../ui-kit';








function ChromaKey({
  chromaKey,
  onChangeAddon,
  CHROMA_KEY,
  disabled
}) {
  return (
    <Dropdown
      options={CHROMA_KEY}
      defaultValue={chromaKey ? CHROMA_KEY.find((key) => key.value === chromaKey) : CHROMA_KEY[0]}
      label="Green Screen"
      onChange={onChangeAddon('CHROMA_KEY')}
      hideSeparators
      showSelectedSuffix
      disabled={disabled}
      type="BUTTON" />);


}

export default memo(ChromaKey);